import React from 'react';
import Text from '@amzn/meridian/text';
import DisplaySubMetric from './DisplaySubMetric';
import Row from '@amzn/meridian/row';
import { FormattedMessage } from 'react-intl';
import { DisplaySubMetricsProps } from '../types';
import {
  PolicyAdherenceDataCheck,
  SUBMETRIC_FONT_SIZE,
  SUBMETRIC_ROW_WIDTHS,
} from '../helper';
import { ControlledExpander } from './Util/ControlledExpander';
import Column from '@amzn/meridian/column';
import NoSubMetric from './Util/NoSubMetric';

const DisplayPolicyAdherenceSubMetrics: React.FC<DisplaySubMetricsProps> = ({
  metrics,
}: DisplaySubMetricsProps): React.ReactElement => {
  if (!metrics.POLICY_ADHERENCE?.submetrics) {
    return <></>;
  }
  if (PolicyAdherenceDataCheck(metrics.POLICY_ADHERENCE?.submetrics!)) {
    return <NoSubMetric />;
  }
  const { concessionGivenRate } = metrics.POLICY_ADHERENCE?.submetrics!;

  return (
    <Column spacing='none' width='100%'>
      {concessionGivenRate && (
        <Row
          alignmentVertical='top'
          width='100%'
          widths={SUBMETRIC_ROW_WIDTHS}
          spacing='none'
          spacingInset='none none 200'
        >
          <ControlledExpander
            title={
              <Text type={SUBMETRIC_FONT_SIZE}>
                <FormattedMessage
                  id='cs_perfportal_lighthouse_concessionGivenRate'
                  defaultMessage='Concession Given Rate'
                />
              </Text>
            }
            type='list'
          >
            <Text type={SUBMETRIC_FONT_SIZE}>
              <FormattedMessage
                id='cs_perfportal_lighthouse_concessionGivenRate_def'
                defaultMessage='Percentage of handled contacts where a concession is issued to the customer.'
              />
            </Text>
          </ControlledExpander>
          <DisplaySubMetric
            value={concessionGivenRate.datapoint}
            isBold
            isPercentage
          />
          <DisplaySubMetric
            value={concessionGivenRate.networkAverage}
            isPercentage
            datapointNull={concessionGivenRate.datapoint === null}
          />
        </Row>
      )}
    </Column>
  );
};

export default DisplayPolicyAdherenceSubMetrics;
